import { render, staticRenderFns } from "./CreateTemplateGroup.vue?vue&type=template&id=2cbc4b6b&scoped=true"
import script from "./CreateTemplateGroup.vue?vue&type=script&lang=js"
export * from "./CreateTemplateGroup.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateGroup.vue?vue&type=style&index=0&id=2cbc4b6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc4b6b",
  null
  
)

export default component.exports